import { StorageService } from '@core/storage/storage.service';
import { ClientSettings, IConfig } from './config.interfaces';

export class BaseConfigService {

     private readonly key = 'settings';
     public readonly config: IConfig;
     public clientSettings: ClientSettings = {
          mapkey: ''
     };

     constructor(private _storageService: StorageService) {
          this.config = this.getClientConfig();
          this.getClientSettings();
     }

     getClientSettings() {
          let url = `${this.config.clientCdnUrl}${this.config.clientId}/config.json`;
          const settings = this._storageService.getItem(this.key);
          if (!!settings) {
               let nowDate = new Date();
               let thenDate = new Date((<ClientSettings>settings).date);
               let dateDiff = (nowDate.getTime() - thenDate.getTime());
               if(dateDiff < (24 * 60 * 60 * 1000)) {
                    return new Promise<ClientSettings>((resolve, _reject) => {
                         this.clientSettings = settings;
                         resolve(<ClientSettings>settings);
                    });
               }
          }

          return fetch(url).then(data => data.json() as ClientSettings).then(clientSettings => {
               clientSettings.date = new Date();
               this._storageService.setItem(this.key, clientSettings);
               this.clientSettings = clientSettings;
               return clientSettings;
          });
     }

     getClientConfig() {
          let clientId = this._getClientId();
          // let clientCdn = this._getConfigItem('data-clientcdn');
          let token = this._getConfigItem('data-tokenurl');
          let apiurl = this._getConfigItem('data-apiurl');
          let cdnUrl = this._getConfigItem('data-cdn');

          if (!token) {
               token = 'https://genius-cp-api.ats.careers/Token';
          }

          if (!apiurl) {
               apiurl = 'https://genius-cp-api.ats.careers/api/';
          }

          if (!cdnUrl) {
               cdnUrl = 'https://cdn.ats.careers/geniusats/';
          }

          let clientCdnUrl =  cdnUrl + 'clients/';

          return <IConfig>{
               apiRootUrl: apiurl,
               clientId: clientId,
               clientCdnUrl: clientCdnUrl,
               apiTokenUrl: token,
               apiVersion: '',
               cdn: cdnUrl,
               hasVideo: false
          };
     }

     protected _resolveUrl(urlToResolve: string) {
          let resolvedUrl = urlToResolve;
          resolvedUrl = resolvedUrl.replace('{clientId}', this.config.clientId);
          resolvedUrl = resolvedUrl.replace('{clientCdnUrl}', this.config.clientCdnUrl);
          resolvedUrl = resolvedUrl.replace('{cdn}', this.config.cdn);
          resolvedUrl = resolvedUrl.replace('{api}', this.config.apiRootUrl);
          resolvedUrl = resolvedUrl.replace('{version}', this.config.apiVersion);
          resolvedUrl = resolvedUrl.replace(/\/+/ig, '/');
          return this._removeDoubleSlash(resolvedUrl);
     }

     protected _removeTrailingSlash(urlToResolve: string) {
          return urlToResolve.replace(/\/$/ig, '');
     }

     protected _removeDoubleSlash(urlToResolve: string) {
          return urlToResolve.replace(/\/+/ig, '/').replace(':/', '://');
     }

     private _getClientId() {
          let CLIENT_ID = null;
          let head = document.head;
          CLIENT_ID = head.getAttribute('data-clientid');
          if (!/^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-5][0-9a-f]{3}-?[089ab][0-9a-f]{3}-?[0-9a-f]{12}$/i.test(CLIENT_ID)) {
               throw new Error('Not a valid client ID');
          } else {
               CLIENT_ID = CLIENT_ID.toUpperCase();
          }
          return CLIENT_ID;
     }

     private _getConfigItem(selector: string) {
          let head = document.head;
          return head.getAttribute(selector);
     }
}
